import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'
import Project from '../../../../../../../../common/project'
import { ProfileReport } from 'common/types/ReportProfile'

export function useReportProfile() {
  const { executeRecaptcha } = useGoogleReCaptcha()

  const reportProfile = async (data: ProfileReport) => {
    if (!executeRecaptcha) {
      console.info('Recaptcha hook did not load the executeRecaptcha script.')
      return
    }

    const token = await executeRecaptcha('submit')

    const response = await fetch(
      `${Project.liveApi}legal-services/profile-report/`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...data,
          captcha_token: token,
        }),
        redirect: 'follow',
      },
    )

    if (!response.ok) {
      throw new Error('Failed to submit report')
    }

    return response
  }

  return { reportProfile }
}
